

const DiagnosticEngagementRoleFilter = (props) => {

    const value = props.value
    const setValue = props.setValue
    const color = props.color
    const label = props.label

    return (
        <div className="comparison-role-container">
            <div className="summary-tabular-controls-text-container">
                <div className={"summary-tabular-colour-circle " + color}/>
                <div className="comparison-role-controls-text">{label}</div>
            </div>
            <div className="summary-tabular-controls-switch">
                <div className={`chart-controls-switch ${value ? "active" : "inactive"}`}
                     onClick={() => setValue(!value)}>
                    <div className="chart-controls-switch-centre"/>
                </div>
            </div>
        </div>
    )

}

export default DiagnosticEngagementRoleFilter;